import Chart from "../Chart/Chart";
import styles from "./StrategiesWiseAnalysis.module.css";

function StrategiesWiseAnalysis({ data = {}, timeFilterOptions = [], defaultTimeFilter = "lastYear" }) {
  return (
    <div className={styles["strategies-analysis"]}>
      <Chart
        chartType="bar"
        dataByDropdown={data}
        defaultDropdownValue={defaultTimeFilter}
        options={{
          height: 300,
          width: "100%",
          title: "Strategies Wise Analysis",
          showTitle: true,
          showHeader: true,
          showDropdown: timeFilterOptions.length > 0,
          dropdownOptions: timeFilterOptions,
          barDataKey: "name",
          barFill: "rgba(79, 70, 229, 0.60)",
          barHighlightedFill: "#4F46E5",
          barRadius: [4, 4, 0, 0],
          showBarGrid: true,
          showBarXAxis: true,
          showBarYAxis: true,
          barYAxisDomain: [0, 90],
          barYAxisTicks: [0, 10, 20, 30, 40, 50, 60, 70, 80, 90],
          barTooltipRows: [
            { label: "Overall P&L", key: "overallPnL" },
            { label: "Drawdown", key: "drawdown" },
            { label: "Winning Streak", key: "winningStreak" },
            { label: "Losing streak", key: "losingStreak" },
          ],
        }}
      />
    </div>
  );
}

export default StrategiesWiseAnalysis;

